import React, { useState } from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Label,
  Input,
} from "reactstrap";
// import { ErrorToast } from "utils/toast";

interface ClientListFilterProps {
  show: boolean;
  onCloseClick: () => void;
  onFilterChange: (filters: { sortBy: string | null }) => void;
}

const SORT_OPTIONS = [
  { label: "Recently Added", value: null },
  { label: "Most Active", value: "ma" },
  { label: "A - Z", value: "asc" },
  { label: "Z - A", value: "desc" },
];

const ClientListFilter: React.FC<ClientListFilterProps> = ({
  show,
  onCloseClick,
  onFilterChange,
}) => {
  const [sortBy, setSortBy] = useState<string | null>(null);

  const handleApply = (e: React.FormEvent) => {
    e.preventDefault();
    onFilterChange({ sortBy });
  };

  const handleClear = () => {
    setSortBy(null);
    onFilterChange({ sortBy: null });
  };

  return (
    <Offcanvas direction="end" isOpen={show} toggle={onCloseClick}>
      <OffcanvasHeader className="bg-light bg-greyF5" toggle={onCloseClick}>
        <div className="text-black2D font-primary fw-medium fs-16">Filters</div>
      </OffcanvasHeader>

      <form className="d-flex flex-column justify-content-end h-100">
        <OffcanvasBody>
          {/* SORT BY */}
          <Label className="text-grey89 font-primary fw-medium fs-14">
            SORT BY
          </Label>

          <div className="my-2">
            {SORT_OPTIONS.map((option, index) => (
              <div
                className="form-check mb-2 d-flex align-items-center gap-2"
                key={index}
              >
                <Input
                  className="form-check-input"
                  type="radio"
                  name="sortBy"
                  id={`sort-${index}`}
                  checked={sortBy === option.value}
                  onChange={() => setSortBy(option.value)}
                />
                <Label
                  className="text-black2D font-primary fw-regular fs-16 mb-0"
                  htmlFor={`sort-${index}`}
                >
                  {option.label}
                </Label>
              </div>
            ))}
          </div>
        </OffcanvasBody>

        {/* FOOTER */}
        <div className="offcanvas-footer border-top p-3 text-center hstack gap-2">
          <button
            type="button"
            className="btn btn-light w-100"
            onClick={handleClear}
          >
            Clear
          </button>

          <button
            type="submit"
            className="btn btn-primary w-100"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      </form>
    </Offcanvas>
  );
};

export default React.memo(ClientListFilter);
